import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import {
    Router,
    NavigationStart,
    NavigationCancel,
    NavigationEnd,
} from "@angular/router";
import {
    Location,
    LocationStrategy,
    PathLocationStrategy,
} from "@angular/common";
import { filter } from "rxjs/operators";
import { AppSettingService } from "src/services/app-setting/app-setting.service";
import { AuthService } from "src/services/auth/auth.service";
import { User } from "src/models/user.model";
import { UserService } from "src/services/user/user.service";
import { PrefectureService } from "src/services/prefecture/prefecture.service";
import { Prefecture } from "src/models/prefecture";
import { CommmuneService } from "src/services/commune/commmune.service";
import { RegionService } from "src/services/region/region.service";
import { CommuneModel } from "src/models/commune.model";
import { Region } from "src/models/region";
import { CountriesService } from "src/services/countries/countries.service";
import { CountriesModel } from "src/models/countries.model";
import { CategoriesService } from "src/services/categories/categories.service";
import { CategoriesModel } from "src/models/categories.model";
import { StaffService } from "src/services/staff/staff.service";
import { Staff } from "src/models/staff.model";
import { FaqService } from "src/services/faq/faq.service";
import { FaqModel } from "src/models/faq.model";

// declare let $: any;

import * as $ from 'jquery';
import { ReloadGuardService } from "src/services/reload-guard/reload-guard.service";
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
    ],
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;
    errorLoading: boolean;
    status: number;

    constructor(
        private router: Router,
        public authService: AuthService,
        private userService: UserService,
        public appSettingService: AppSettingService,
        private _elementRef: ElementRef,
        private prefectureService: PrefectureService,
        private communeService: CommmuneService,
        private regionService: RegionService,
        private countryService: CountriesService,
        private categoryService: CategoriesService,
        private staffService: StaffService,
        private faqService: FaqService,
    ) { }

    ngOnInit() {
        this._elementRef.nativeElement.removeAttribute("ng-version");

        // if (this.swUpdate.isEnabled) {
        //     this.swUpdate.versionUpdates.subscribe(() => {
        //         this.swUpdate.activateUpdate().then(() => document.location.reload());
        //     });
        // }

        // if (this.swUpdate.isEnabled) {
        //     this.swUpdate.versionUpdates.subscribe(() => {
        //         Swal.fire({
        //             title: 'Mise à jour',
        //             text: "Vous utilisez une ancienne version de la plateforme de la BSTP. Voulez-vous effectuer la mise à jour de la dernière version ?",
        //             iconHtml: '<img src="./assets/img/shape/1.png" width="150" height="150">',
        //             customClass: {
        //                 icon: 'no-border'
        //             },
        //             showCancelButton: true,
        //             confirmButtonColor: "#006481",
        //             color: "#006481",
        //             iconColor: "#006481",
        //             cancelButtonColor: "#d33",
        //             confirmButtonText: 'Mettre à jour',
        //             cancelButtonText: 'Annuler',
        //             allowOutsideClick: () => false,
        //         }).then((result) => {
        //             if (result.isConfirmed) {
        //                 window.location.reload();
        //             }
        //         });
        //     });
        // }

        this.recallJsFunctions();

        this.appSettingService
            .get()
            .subscribe({
                next: data => {
                    this.appSettingService.update(data[1]);

                    this.errorLoading = true;

                    this.prefectureService.list().subscribe((prefectures: Array<Prefecture>) => this.prefectureService.update(prefectures));
                    this.communeService.list().subscribe((communes: Array<CommuneModel>) => this.communeService.update(communes));
                    this.regionService.list().subscribe((regions: Array<Region>) => this.regionService.update(regions));
                    this.countryService.list().subscribe((countries: Array<CountriesModel>) => this.countryService.update(countries));
                    this.categoryService.list().subscribe((categories: Array<CategoriesModel>) => this.categoryService.update(categories));
                    this.faqService.list().subscribe((faqs: Array<FaqModel>) => this.faqService.update(faqs));
                },
                error: error => {
                    this.errorLoading = false;
                    if (error.status == 504) {
                        this.status = 504;
                    }
                },
            });

        if (this.authService.isAuthenticated()) {
            this.userService
                .currentUser()
                .subscribe((data: User) => this.authService.update(data));
        }
    }

    recallJsFunctions() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                $(".loader").fadeIn("slow");
            }
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter(
                    (event) =>
                        event instanceof NavigationEnd ||
                        event instanceof NavigationCancel
                )
            )
            .subscribe((event) => {
                $.getScript("../assets/js/custom.js");
                $(".loader").fadeOut("slow");
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }
}
